import React from 'react'
import Hero from '../components/Hero';
import Features from '../components/Features';

function Home() {
    return (
        <div>
            <Hero />
        </div>
    )
}

export default Home;

